// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"a99ed90f","952":"b5387260"}[chunkId] + ".chunk.js";
};